import { createSlice,PayloadAction } from "@reduxjs/toolkit";
import { BudgetModel } from "store/types/models";

const initialState = {
  budget:{} as BudgetModel,
  budgets:[] as BudgetModel[],
};

export const budgetSlice = createSlice({
  name: "BudgetSlice",
  initialState: initialState,
  reducers: {
    setBudgets: (state, action:PayloadAction<BudgetModel[]>) => {
      state.budgets = action.payload
    },
  },
});

export const { setBudgets } = budgetSlice.actions;

export default budgetSlice.reducer;